import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Do not inherit html's smooth anchor scrolling for route changes or Back.
    scrollRestorationBehavior: 'instant',
    // Pages own their fragment scrolling (the footer's #newsletter reveal
    // re-aligns while content settles); a second router scroll fights it.
    defaultHashScrollIntoView: false,
    defaultPreloadStaleTime: 0,
  });

  return router;
};
